export default __webpack_public_path__ + "img/meXTULYl.e061b612.svg";